export default store => next => action => {
  if (action.type === '@@redux-form/CHANGE') {
    store.dispatch({ type: 'forms/REGISTER_DIRTY_FIELD', payload: { form: action.meta.form, fieldPath: action.meta.field } });
  }

  return next(action);
};